import { asBoolean, asNumber, asString } from '../http/normalise';
import { ApiProgrammeState } from './programme-state.dto';
import { ProgrammeApproval, ProgrammeState } from './programme-state.model';

const PROGRAMME_APPROVALS: ReadonlySet<string> = new Set<string>([
  'draft',
  'in-review',
  'approved',
  'changes-requested',
]);

function asApproval(value: unknown): ProgrammeApproval {
  if (typeof value === 'string' && PROGRAMME_APPROVALS.has(value)) {
    return value as ProgrammeApproval;
  }
  return 'draft';
}

export function mapProgrammeState(dto: ApiProgrammeState): ProgrammeState {
  return {
    eventId: asString(dto.eventId) ?? '',
    published: asBoolean(dto.published, false),
    publishedAt: asString(dto.publishedAt),
    approval: asApproval(dto.approval),
    approvalNote: asString(dto.approvalNote),
    approvedAt: asString(dto.approvedAt),
    sessionCount: asNumber(dto.sessionCount) ?? 0,
    speakerCount: asNumber(dto.speakerCount) ?? 0,
  };
}
